<template>
    <div class="h-100 pt-sm-12 pt-md-2">
        <v-row v-if="ready && gateway">
            <v-col order-md="last" cols="12" md="4">
               <infoMeter :gateway="gateway" :meters="meters" :lastReadings="lastReadings"/>
            </v-col>
            <v-col cols="12" md="8">
                <graphs :gateway="gateway" :meters="meters" style="height: 65vh"/>
                <simulator class="mt-6" :gateway="gateway" :meters="meters" style="height: 28vh"/>
            </v-col>
        </v-row>
        <v-row v-if="ready && gateway">
            <v-col cols="12">
                <tableReport :meters="meters" :plant="gateway_id"/>
            </v-col>
        </v-row>
        <v-row v-if="!ready" class="text-center align-center h-100">
            <v-col>
                <v-progress-circular
                    width="5"
                    size="50"
                    indeterminate
                    color="accent"
                ></v-progress-circular>
            </v-col>
        </v-row>
        <div v-if="ready && !gateway" class="d-flex h-100 text-caption">
            <div class="ma-auto text-center">
                <v-icon x-large>mdi-menu-open</v-icon>
                <p class="mt-3 mb-0 grey--text font-weight-bold darken text--darken-1">Selecciona un punto de medición</p>
            </div>
        </div>
    </div>
</template>

<script>
import { LINE1, LINE2, LINE3 } from '../components/graphs/props-types'
import { WATTS, AMPS, VOLTS, KWH } from '../components/graphs/props-types'
import { COLUMS, LINES } from '../components/graphs/props-types'
import Chart from '../components/graphs/modules/Chart.js'
import tableReport from '../components/Plants/table'
import { mapGetters, mapState, mapActions } from 'vuex'
import infoMeter from '../components/Plants/info'
import graphs from '../components/Plants/graphs'
import simulator from '../components/Plants/simulator'

export default {
    name: 'Plant',
    components: { infoMeter, graphs, tableReport, simulator },
    computed: {
        ...mapState({
            gateway_id: state => state.gateways.selected,
            gateway(state){
                if(!this.gateway_id) return null
                return state.gateways.list.find(g => g.id === this.gateway_id)
            },
            meters(state){
                if(!this.gateway_id) return null
                return state.meters.list.filter(m => m.gateway === this.gateway_id)
            },
            lastReadings(state){
                if(!this.meters) return null
                if(!state.meters.lastReadings) return null
                const meters = this.meters.map( m => m.id )
                return state.meters.lastReadings.filter( r => meters.includes(r.meter) )
            }
        }),
        ...mapGetters({
            getGateway: 'gateways/getGateway',
            getMeters: 'meters/getMetersGtw'
        })
    },
    data() {
        return {
            Chart,WATTS, AMPS, VOLTS, KWH, COLUMS, 
            LINES,LINE1, LINE2, LINE3,
            ready: true
        };
    },
    methods:{
        ...mapActions({ 
            updatedView: 'user/updatedView'
        }),
        async refresh(){
            this.ready = false
            this.ready = true
        }
    },
    watch:{
        gateway_id(){
            this.refresh()
        },
    },
    mounted(){
        this.updatedView('Plant')
    }
}
</script>

<style scoped>
.h-100{
    height: 100% !important;
}
</style>
